import { FlujoAprobacionReadingDtoProps } from "api/DTOs/FlujoAprobacionReadingDto"
import CustomButton from "common/components/Button/Button"
import CustomConfirmDialog from "common/components/ConfirmDialog"
import HeaderWrapper from "common/components/HeaderWrapper"
import notification from "common/utils/notification"
import { approvalsServices } from "features/User/pages/ApprovalsManagement/services/approvals"
import { getApprovals } from "features/User/redux/selectors/approvalsSelectors"
import {
  fetchAprovalList,
  resetApprovals,
} from "features/User/redux/slices/approvalSlices"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ApprovalsModal from "./components/AprovalsModal"
import { PageInner } from "./components/PageInner"

import "./style.scss"

const ApprovalsManagement = () => {
  const { t } = useTranslation()
  const [show, setShow] = useState({ id: null, status: false })
  const [showDelete, setShowDelete] = useState({ id: null, status: false })
  const dispatch = useDispatch()
  const aprobaciones = useSelector(getApprovals)

  useEffect(() => {
    dispatch(fetchAprovalList())
    return () => {
      dispatch(resetApprovals())
    }
  }, [dispatch])

  const handleModal = (id: $TSMigrationFixMe) => {
    setShow({ id: id || null, status: !show.status })
  }
  const handleModalDelete = (id: $TSMigrationFixMe) => {
    setShowDelete({ id: id || null, status: !showDelete.status })
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const handleCreateUpdateApproval = async (values: $TSMigrationFixMe) => {
    try {
      show.id
        ? await approvalsServices.updateApproval(values)
        : await approvalsServices.createApproval(values)
      notification.success({
        body: show.id
          ? `${t("flujoAprobaciones.editExist")}`
          : `${t("flujoAprobaciones.newExist")}`,
      })
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      handleModal()
      dispatch(fetchAprovalList())
    } catch (err) {
      return err
    }
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const handleDeleteApproval = async () => {
    try {
      await approvalsServices.deleteApproval(showDelete.id)

      notification.success({ body: `${t("flujoAprobaciones.deleteExist")}` })
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      handleModalDelete()
      dispatch(fetchAprovalList())
    } catch (err) {
      return err
    }
  }

  const newAprobaciones = aprobaciones?.map(
    (item: FlujoAprobacionReadingDtoProps) => ({
      ...item,
      onDelete: () => handleModalDelete(item.id),
      onEdit: () => handleModal(item.id),
    })
  )

  return (
    <>
      <section className='tw-p-4'>
        <div>
          <HeaderWrapper
            title={`${t("flujoAprobaciones.title")}`}
            className='mb-4 aprovals-management__header d-flex align-items-center justify-content-between'
          >
            <CustomButton
              // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
              onClick={() => handleModal()}
              className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none'
            >
              {t("flujoAprobaciones.newFlow")}
            </CustomButton>
          </HeaderWrapper>
          <PageInner data={newAprobaciones} />
        </div>
      </section>
      <ApprovalsModal
        show={show}
        setShow={handleModal}
        sendRequest={handleCreateUpdateApproval}
      />
      <CustomConfirmDialog
        visible={showDelete.status}
        onHide={handleModalDelete}
        closable
        message={<span>{t("flujoAprobaciones.deleteFlujo.deleteMsg")}</span>}
        header={
          <div className='d-flex justify-content-start'>
            <h6>{t("flujoAprobaciones.deleteFlujo.deleteFlow")}</h6>
          </div>
        }
        acceptLabel={`${t("flujoAprobaciones.deleteFlujo.accept")}`}
        rejectLabel={`${t("flujoAprobaciones.deleteFlujo.denegade")}`}
        accept={handleDeleteApproval}
      />
    </>
  )
}

export default ApprovalsManagement
